import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppProvider from "./AppProvider";
import SignInPage from "./pages/signin/SignInPage";
import MainPage from "./pages/main/MainPage";
import SignUpPage from "./pages/signup/SignUpPage";
import AccessDeniedPage from "./pages/denied";
import Queue from "nq-js";
import RedirectPage from "./pages/RedirectPage";
import TestPage from "./pages/TestPage";
import TenantPage from "./pages/TenantPage";
import SurveyFormPage from "./pages/survey-form/form/SurveyFormPage";
import ThanksPage from "./pages/survey-form/form/components/ThanksPage";

Queue.setUrl("https://api.innque.com/v1");
Queue.setApplicationId("lgs");

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/test" element={<TestPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signin/:master" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/redirect/:id" element={<RedirectPage />} />
          <Route path="/app" element={<TenantPage />} />
          <Route path="/survey/:recruiterId" element={<SurveyFormPage />} />
          <Route
            path="/survey-form/2557864545324234"
            element={<ThanksPage />}
          />
          <Route path="/*" element={<MainPage />} />
          <Route path={"/denied"} element={<AccessDeniedPage />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
